import Repository from "./Repository";

export default {
  getUnRegistersSchools(payload) {
    return Repository.get(
      `/un-registered-schools?county=${payload.county}&state=${payload.state}&institute=${payload.institute}&pageSize=${payload.pageSize}&lastDocId=${payload.lastDocId}`
    );
  },
};
